import React from 'react';
import { FieldPattern } from '..';

import { TEXT } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class TextFormField extends FormFieldWithInitialValue {
  readonly type: string = TEXT;
  fieldType: string;
  shouldShowIcon;
  focusIcon: React.FC<any> | undefined;
  isFieldDisabled = false;
  reRenderedFields!: Array<string>;
  shouldShowOtpField: boolean;
  pattern: string;
  shouldVerifyEmail: boolean;
  dependentOnFields: string[];
  constructor(
    textFieldData: FormFieldsType,
    initialValue = '',
    fieldType = 'text',
    focusIcon?: React.FC<any>,
    reRenderedFields: Array<string> = []
  ) {
    super(textFieldData, initialValue);
    this.fieldType = fieldType;
    this.shouldShowIcon = textFieldData.should_show_icon ?? true;
    this.focusIcon = focusIcon;
    this.isFieldDisabled = initialValue ? true : false;
    this.reRenderedFields = reRenderedFields;
    this.shouldShowOtpField = textFieldData.should_show_otp_field ?? false;
    this.placeholder = textFieldData.placeholder
      ? textFieldData.placeholder
      : '';
    this.shouldShowLabel = textFieldData.shouldShowLabel;
    this.pattern = textFieldData.pattern ? textFieldData.pattern : '';
    this.shouldVerifyEmail = textFieldData.should_verify_email ?? false;
    this.dependentOnFields = textFieldData.dependent_on_fields
      ? textFieldData.dependent_on_fields
      : [];
  }
  match<T>(p: FieldPattern<T>): T {
    return p.TextFormField(this);
  }
}

export default TextFormField;
